export type Subscriber = (data: any) => void;

export class Observer {
    observers: Array<Subscriber> = [];

    subscribe(fn: Subscriber) {
        this.observers.push(fn);
    }

    unsubscribe(fn: Subscriber) {
        this.observers = this.observers.filter((subscriber) => subscriber !== fn);
    }

    broadcast(data: any) {
        this.observers.forEach((subscriber) => subscriber(data));
    }
}
